/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import { Text } from './Text';
import { Title } from './Title';

const ChangeEmailExpired = () => {
  const { t } = useTranslation();

  return (
    <>
      <Icon type={'error'} />
      <Title>{t('NOTIFICATION_CHANGE_EMAIL_EXPIRED_MODAL__title')}</Title>
      <Text>{t('NOTIFICATION_CHANGE_EMAIL_EXPIRED_MODAL__desc')}</Text>
    </>
  );
};

export { ChangeEmailExpired };
